// hearthcmd.com/kiosk.sh is a small wrapper (website repo) that runs the kiosk
// installer from the latest CLI release's tag (cli/scripts/kiosk-install.sh here),
// the way hearthcmd.com/install.sh installs the CLI.
export const KIOSK_INSTALL_URL = 'https://hearthcmd.com/kiosk.sh'

// kioskInstallCommand is the one-liner that turns a Pi into a screen for the display
// at url (a LAN address the display server reported, e.g. http://192.168.1.20:8090).
export function kioskInstallCommand(url: string): string {
  return `curl -fsSL ${KIOSK_INSTALL_URL} | bash -s -- ${url}`
}
